import React, {ReactNode} from 'react';
import FaiBox from "../../MuiComponents/FaiBox";
import boxShadows from "../../assets/theme/base/boxShadows";

const Strip: React.FC<{ children?: ReactNode }> = (props) => {
    return (
        <>
            <FaiBox bgColor={"#E091451A"} boxShadow={boxShadows.xs}>
                {props.children}
            </FaiBox>
        </>
    );
}

export default Strip;
